import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconShuffle",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function f(e, t, i, m, _, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--shuffle"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Shuffle",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.647 1.647a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1-.707.707l-2.5-2.5a.5.5 0 0 1 0-.707Z",
      fill: "currentColor"
    }, null, -1),
    l("path", {
      d: "M7.5 1.5A.5.5 0 0 1 8 1h2.5a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V2.707l-7.646 7.647a.5.5 0 0 1-.707-.707L9.293 2H8a.5.5 0 0 1-.5-.5Zm3 6a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5H8a.5.5 0 1 1 0-1h1.293L7.147 7.854a.5.5 0 0 1 .707-.707L10 9.293V8a.5.5 0 0 1 .5-.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const S = /* @__PURE__ */ s(c, [["render", f]]);
export {
  S as default
};
//# sourceMappingURL=shuffle.js.map
